import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/download`;

export const DL_MAJOR_DEBUT = `${ROOT}/majorDebut.svg`;
export const DL_RECOM_PHO = `${ROOT}/recomPh.png`;
export const DL_BK = `${ROOT}/bk.png`;
export const DL_RIGHT_STAR = `${ROOT}/right-star.png`;
export const DL_ARROW = `${ROOT}/arrow.png`;
export const DL_MAN = `${ROOT}/man.png`;
export const DL_PEOPLE = `${ROOT}/people.png`;
export const DL_Y = `${ROOT}/Y.png`;
